import { iconMapping } from "../../config/iconConfig";
import "./Button.css";

const ButtonWithIcon = ({
  value,
  onClick = () => {},
  icon,
  disabled = false,
  className = "",
  isLightBlue = true,
  isInTopBar = false,
}) => {
  const IconComponent = iconMapping[icon];

  return (
    <button
      className={`App-button App-button-with-icon App-text-medium widget-action-button
          ${disabled ? "App-button-disabled" : ""} ${className}  ${
        isLightBlue ? "App-button-light-blue" : "App-button-dark-blue"
      } ${isInTopBar ? "App-button-in-top-bar" : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="App-button-with-icon-wrapper">
        {IconComponent && <IconComponent />}
        <span className="App-button-with-icon-value">{value}</span>
      </div>
    </button>
  );
};

export default ButtonWithIcon;
